export { FormatPhonePipe } from './format-phone.pipe';
